import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

import { ActivityNewRoutingModule } from './activity-new-routing.module';
import { ActivityNewComponent } from './activity-new.component';
import { ActivityActionModalComponent } from './activity-action-modal/activity-action-modal.component';


@NgModule({
  declarations: [
    ActivityNewComponent,
    ActivityActionModalComponent
  ],
  imports: [
    CommonModule,
    ActivityNewRoutingModule,
    MatDialogModule
  ],
  exports: [
    ActivityNewComponent
  ]
})
export class ActivityNewModule { }
